import { Box, ListItemButton, Typography } from "@mui/material";
import { InvoiceStatusChip } from "./InvoiceStatusChip";
import { getInvoiceStatus } from "../../utils/getInvoiceStatus";
import type { IInvoice } from "../../../create/interfaces/invoice.interfaces";

interface InvoiceListItemProps {
  invoice: IInvoice;
  onClick: () => void;
  /** Optional slot rendered to the right of the chip (e.g. a delete icon for a specific status). */
  trailing?: React.ReactNode;
}

const formatDate = (raw?: string) =>
  raw ? new Date(raw).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "";

const formatAmount = (value: number) =>
  `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const InvoiceListItem = ({ invoice, onClick, trailing }: InvoiceListItemProps) => {
  const status = getInvoiceStatus(invoice);
  const amount = invoice.totalCost?.total?.value ?? 0;
  const created = formatDate(invoice.createdAt as unknown as string);

  return (
    <ListItemButton onClick={onClick} sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 0.5 }}>
        <Typography variant="body2" fontWeight={600}>
          {invoice.identifierId ?? invoice.uid?.slice(0, 8)}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {formatAmount(amount)}
          {created && ` • ${created}`}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
          {`${invoice.uid}`}
        </Typography>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
        <InvoiceStatusChip status={status} />
        {trailing}
      </Box>
    </ListItemButton>
  );
};
